import $ from "jquery";

const wpActivate = () => {
    if (!document.getElementById('signup-welcome')) return;

    const init = () => {
        bindCopyButtons();
    };

    const copyToClipboard = (value) => {
        if (navigator.clipboard && window.isSecureContext) {
            return navigator.clipboard.writeText(value);
        } else {
            const $temp = $('<textarea>');
            $('body').append($temp);
            $temp.val(value).select();
            document.execCommand('copy');
            $temp.remove();
            return Promise.resolve(); // eslint-disable-line no-undef
        }
    };

    const showCopied = () => {
        const $toast = $('<div class="copy-toast">Copied!</div>');
        $('body').append($toast);
        setTimeout(() => $toast.remove(), 2000);
    };

    const bindCopyButtons = () => {
        $('#signup-welcome p').on('click', function () {
            const $p = $(this);
            const $clone = $p.clone();
            $clone.find('span').remove();
            const value = $clone.text().trim();

            if (!value) return;

            copyToClipboard(value).then(() => {
                $p.addClass('is-copied');
                showCopied();
                setTimeout(() => {
                    $p.removeClass('is-copied');
                }, 2000);
            });
        });
    };

    init();
};

try {
    wpActivate();
} catch (error) {
    console.error('wp-activate', error);
}